<div [class.active]="active" class="date-time">
  <div (click)="active = false; activeChange.emit(active)" class="date-time__backdrop"></div>
  <main>
    <ncis-datetime-navigation (next)="next()" (prev)="prev()" [currentDate]="currentDate"></ncis-datetime-navigation>
    <ncis-datetime-day (select)="select($event)" [currentDate]="currentDate" [max]="max" [min]="min" [selectedDate]="selectedDate"></ncis-datetime-day>
  </main>
</div>
